<template>
  <section class='page-account'>
    <div class="account-title">
      <span>手机号密码登录</span>
    </div>
    <van-form class="mt35">
      <van-field
        class="input-border"
        v-model="tel"
        ref="telInput"
        type="tel"
        label="+86"
        :clearable="true"
        placeholder="请输入手机号"
        label-width="50"
        @click="handleFocusTel"
        @blur="isShowAgreement = true;"
        autocomplete="off"
      />
      <div class="password mt25">
        <div>密码</div>
        <van-field
          autocomplete="off"
          class="input-border"
          v-model="password"
          :type="passwordType"
          placeholder="请输入密码"
          :clearable="true"
          ref="pswInput"
          @click="handleFocusPsw"
          @blur="isShowAgreement = true;"
          @focus="passwordType = 'password'"
        />
      </div>
      <div
        class="err-tip"
        :style="isShowErr ? 'opacity: 1':'opacity: 0'"
      >
        账号或密码错误
      </div>
      <div>
        <van-button
          @click="onSubmit"
          block
          type="info"
          native-type="submit"
          :disabled="repeatClick"
        >
          登录
        </van-button>
      </div>
    </van-form>
    <span
      class="mt30"
      @click="handleRetrievePassword"
    >
      忘记了？找回密码
    </span>
    <div :class="isShowAgreement ? 'agreement' : 'agreement-hide'">
      登录即表您已阅读并同意
      <router-link
        :to="{ name: 'agreementUser'}"
        tag="span"
      >
        《用户协议》,
      </router-link>
      <router-link
        :to="{ name: 'agreementLaw'}"
        tag="span"
      >
        《法律声明》,
      </router-link>
      <router-link
        :to="{ name: 'agreementPrivacy'}"
        tag="span"
      >
        《隐私权协议》
      </router-link>
    </div>
  </section>
</template>

<script>
/* eslint-disable import/no-cycle */
import md5 from 'js-md5';
import { validatePhoneNumber, loginJump } from '@/assets/utils/utils';
import { apiPassLogin, apiSendCode } from '@/api/login/index';
import { gt } from '@/components/geetest/index';

export default {
  name: 'account',
  mixins: [gt],
  data() {
    return {
      docmHeight: document.documentElement.clientHeight, // 默认屏幕高度
      showHeight: document.documentElement.clientHeight, // 实时屏幕高度
      isShowAgreement: true,
      repeatClick: false,
      tel: '',
      password: '',
      isShowErr: false,
      clickTap: '',
      passwordType: 'text',
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.$NProgress.done();
      window.addEventListener('resize', this.handleScroll);
    });
  },
  watch: {
    showHeight() {
      if (this.docmHeight > this.showHeight) {
        this.isShowAgreement = false;
      } else {
        this.isShowAgreement = true;
      }
    },
    tel() {
      this.isShowErr = false;
    },
    password() {
      this.isShowErr = false;
    },
  },
  methods: {
    handleScroll() {
      this.showHeight = document.body.clientHeight;
    },
    getCode(val) {
      apiSendCode({
        mobile: this.tel,
        ...val,
        type: 1,
      }).then(() => {
        this.$captchaObj.reset();
        this.$router.push({
          name: 'retrievePassword',
          query: {
            tel: this.tel,
          },
        });
      }).catch(() => {
        this.$captchaObj.reset();
      });
    },
    handleFocusTel() {
      this.$refs.telInput.focus();
      this.isShowAgreement = false;
    },
    handleFocusPsw() {
      this.$refs.pswInput.focus();
      this.isShowAgreement = false;
    },
    onSubmit() {
      this.isShowErr = false;
      this.clickTap = 'login';
      if (!validatePhoneNumber(this.tel)) {
        this.$toast('请输入正确手机号');
      } else if (!this.password) {
        this.$toast('请输入密码');
      } else {
        this.$captchaObj.verify();
      }
    },
    handleRetrievePassword() {
      this.clickTap = 'forget';
      if (validatePhoneNumber(this.tel)) {
        this.$captchaObj.verify();
      } else {
        this.$toast('请输入正确手机号');
      }
    },
    async gtSuccess(val) {
      try {
        if (this.clickTap === 'forget') {
          this.getCode(val);
          return;
        }
        const res = await apiPassLogin({
          mobile: this.tel,
          ...val,
          password: md5(this.password),
        });
        this.$captchaObj.reset();
        this.isShowErr = false;
        const { data } = res;
        window.sessionStorage.setItem('DbAuthtoken', data.accessToken);
        loginJump();
      } catch (err) {
        this.$captchaObj.reset();
        this.isShowErr = true;
        this.repeatClick = false;
      }
    },
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleScroll);
  },
};
</script>

<style lang='less' scoped>
.page-account {
  padding: 25px 20px 0;
  font-size: 14px;
  text-shadow: none;
  color: rgba(51,51,51,1);
  height: 100vh;
  .mt30{
    color: rgba(79,121,255,1);
    display: inline-block;
  }
  .account-title{
    color: rgba(3,3,3,1);
    font-size: 24px;
  }
  .van-field {
    padding-left: 0;
    padding-right: 0;
  }
  .password{
    >div:first-child{
      margin-bottom: 5px;
      font-size: 16px;
      color: rgba(3,3,3,1);
    }
  }
  .err-tip{
    color: rgba(248,142,38,1);
    margin-bottom: 10px;
    margin-top: 5px;
  }
  .agreement{
    font-size: 12px;
    position: fixed;
    bottom: 40px;
    left: 0;
    right: 0;
    line-height: 20px;
    padding: 20px;
    >span{
      color: rgba(79,121,255,1);
    }
  }
  .agreement-hide {
    position: relative;
    z-index: -1;
    opacity: 0;
  }
}
</style>
